import { getConfig } from '../lib/config';
import { client } from './generated/client.gen';

export function initApiClient(): void {
  client.setConfig({
    baseURL: getConfig().apiUrl,
  });
}
